import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { initialize } from './actions/AppAction';
import { authStateChanged } from './actions/AuthAction';
import ArticlePage from './components/article/ArticlePage';
import ArticlesPage from './components/article/ArticlesPage';
import CharacterPage from './components/character/CharacterPage';
import CharactersPage from './components/character/CharactersPage';
import EditCharacterPage from './components/character/EditCharacterPage';
import IdentifyCharacterPage from './components/character/IdentifyCharacterPage';
import RefreshCharacterGameDataPage from './components/character/RefreshCharacterGameDataPage';
import VerifyCharacterPage from './components/character/VerifyCharacterPage';
import Footer from './components/Footer';
import IndexPage from './components/IndexPage';
import Navbar from './components/Navbar';
import NotFoundPage from './components/NotFoundPage';
import OcrPage from './components/OcrPage';
import SignInPage from './components/SignInPage';
import SignOutPage from './components/SignOutPage';
import SignUpPage from './components/SignUpPage';
import { auth } from './firebase/Firebase';

class App extends Component {
  componentDidMount() {
    this.authUnsubscribe = auth.onAuthStateChanged(user => {
      this.props.authStateChanged(user);

      if (user !== null) {
        this.props.initialize();
      }
    });
  }

  componentWillUnmount() {
    this.authUnsubscribe();
  }

  render() {
    const { user } = this.props.authState;

    let routes;
    if (user) {
      routes = (
        <Switch>
          <Route exact path="/" component={IndexPage} />
          <Route exact path="/articles/" component={ArticlesPage} />
          <Route exact path="/articles/:articleId" component={ArticlePage} />
          <Route exact path="/sign-up" component={SignUpPage} />
          <Route exact path="/sign-in" component={SignInPage} />
          <Route exact path="/sign-out" component={SignOutPage} />
          <Route exact path="/ocr" component={OcrPage} />
          <Route exact path="/characters/" component={CharactersPage} />
          <Route exact path="/characters/identify" component={IdentifyCharacterPage} />
          <Route exact path="/characters/new" component={EditCharacterPage} />
          <Route exact path="/characters/:characterId" component={CharacterPage} />
          <Route exact path="/characters/:characterId/edit" component={EditCharacterPage} />
          <Route exact path="/characters/:characterId/refresh-game-data" component={RefreshCharacterGameDataPage} />
          <Route exact path="/characters/:characterId/verify" component={VerifyCharacterPage} />
          <Route component={NotFoundPage} />
        </Switch>
      );
    } else {
      routes = (
        <Switch>
          <Route exact path="/" component={IndexPage} />
          <Route exact path="/articles/" component={ArticlesPage} />
          <Route exact path="/articles/:articleId" component={ArticlePage} />
          <Route exact path="/sign-up" component={SignUpPage} />
          <Route exact path="/sign-in" component={SignInPage} />
          <Route exact path="/sign-out" component={SignOutPage} />
          <Route component={IndexPage} />
        </Switch>
      );
    }

    return (
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <div className="App">
          <Navbar />
          {routes}
          <Footer />
        </div>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authState: { ...state.authState },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initialize: () => {
      dispatch(initialize());
    },
    authStateChanged: (user) => {
      dispatch(authStateChanged(user));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
